/**
 * 엑셀형 열 필터 (멀티 체크) 유틸
 * filterValue: { selected: string[] } | undefined
 * - selected에 포함된 표시키만 통과
 * - 빈 셀은 EMPTY_VALUE_KEY 로 정규화
 */

export const EMPTY_VALUE_KEY = '(빈 값)';

export function toFilterKey(value) {
  if (value == null || value === '') return EMPTY_VALUE_KEY;
  return String(value);
}

/**
 * TanStack columnFilters.filterFn
 * @param {import('@tanstack/react-table').Row} row
 * @param {string} columnId
 * @param {{ selected?: string[] }|undefined} filterValue
 */
export function excelMultiSelectFilterFn(row, columnId, filterValue) {
  if (!filterValue || !Array.isArray(filterValue.selected)) return true;
  const key = toFilterKey(row.getValue(columnId));
  return filterValue.selected.includes(key);
}

/**
 * Map / Iterable → 정렬된 unique 키 배열
 * @param {Map|Iterable} facetedMap
 */
export function facetedMapToKeys(facetedMap) {
  if (!facetedMap) return [];
  const keys = [];
  if (typeof facetedMap.forEach === 'function') {
    facetedMap.forEach((_count, value) => {
      keys.push(toFilterKey(value));
    });
  } else {
    for (const value of facetedMap) {
      keys.push(toFilterKey(Array.isArray(value) ? value[0] : value));
    }
  }
  return keys.sort((a, b) => {
    if (a === EMPTY_VALUE_KEY) return 1;
    if (b === EMPTY_VALUE_KEY) return -1;
    return String(a).localeCompare(String(b), 'ko');
  });
}
